import { OnInit } from "@angular/core";
import { Component } from "@angular/core";
import { MenuItems } from "./api/menuitems";

@Component({
  standalone: false,
  selector: "app-menu",
  templateUrl: "./app.menu.component.html",
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];

  ngOnInit() {
    // Simplified menu initialization without auth
    this.model = MenuItems.map((m) => ({
      label: m.label,
      icon: m.icon,
      items: m.items,
    }));
  }
}
